export default {
	attributes: {
		title: 'Title for This Block',
		showTitle: true,
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		text: '<p>Some short text that can be expanded to show more details.</p>',
		moreText: '<p>Some short text that can be expanded to show more details. Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.</p>',
		textFontSize: 16,
		textLineHeightUnit: 'em',
		textTabletLineHeightUnit: 'em',
		textMobileLineHeightUnit: 'em',
		moreLabel: 'Show more',
		lessLabel: 'Show less',
		linkFontSize: 18,
		linkLineHeightUnit: 'em',
		linkTabletLineHeightUnit: 'em',
		linkMobileLineHeightUnit: 'em',
		uniqueClass: 'ugb-84c0eed',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
	},
}
